import 'scss/services/medicalMic.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
$(function () {
  serviceQA()
  serviceTopbar()
  $('#applyNow').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=466c640f562a4fd99abff4c80f152bc7&tid=95e30bd4eb2d46a5979675854672835d&categoryName=医疗麦克风&tname=商务接洽&title=医疗麦克风 - 服务申请&id=medicalMic`)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/medicalMic.js